import { render, staticRenderFns } from "./DetailsItem.vue?vue&type=template&id=f49d6400&"
import script from "./DetailsItem.vue?vue&type=script&lang=ts&"
export * from "./DetailsItem.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports